var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14.9965,
    height: 14.9965,
    viewBox: "0 0 14.9965 14.9965",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.99922 10.4975V3.74913C2.99922 3.3514 3.15722 2.96995 3.43846 2.68872C3.7197 2.40748 4.10114 2.24948 4.49887 2.24948H8.99781L11.9971 5.24877V10.4975C11.9971 10.8953 11.8391 11.2767 11.5579 11.5579C11.2766 11.8392 10.8952 11.9972 10.4975 11.9972H4.49887C4.10114 11.9972 3.7197 11.8392 3.43846 11.5579C3.15722 11.2767 2.99922 10.8953 2.99922 10.4975Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.04975
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.99771 2.24948V5.24877H11.997M7.49806 6.74842V10.4975M9.37262 8.62298L7.49806 6.74842L5.6235 8.62298",
    stroke: "#9CA3AF",
    strokeWidth: 1.04975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.cec164e3d643eb11954745c175ce99c7.svg";
export { ForwardRef as ReactComponent };